"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findKettenSystemGroup = exports.KettenSystemGroup = void 0;
var KettenSystemGroup;
(function (KettenSystemGroup) {
    KettenSystemGroup["DEFAULT"] = "DEFAULT_SYSTEM_GROUP";
    KettenSystemGroup["UNKNOWN"] = "UNKNOWN_SYSTEM_GROUP";
    KettenSystemGroup["HALBSTEGIG_E4_1_OR_E4_00"] = "HALBSTEGIG_E4_1_OR_E4_00";
    KettenSystemGroup["HALBSTEGIG_E61_OR_E6"] = "HALBSTEGIG_E61_OR_E6";
    KettenSystemGroup["HALBSTEGIG_E4_4_OR_E4_light"] = "HALBSTEGIG_E4_4_OR_E4_light";
})(KettenSystemGroup = exports.KettenSystemGroup || (exports.KettenSystemGroup = {}));
const SYSTEM_KUERZEL = {
    [KettenSystemGroup.HALBSTEGIG_E4_1_OR_E4_00]: ['E4_1', 'E4_00', 'E4_0', 'E4_Q'],
    [KettenSystemGroup.HALBSTEGIG_E61_OR_E6]: ['E6_1', 'E6', 'E6_esd'],
    [KettenSystemGroup.HALBSTEGIG_E4_4_OR_E4_light]: ['E4_4', 'E4_light'],
};
const findKettenSystemGroup = ({ EchainSystem }) => {
    if (!EchainSystem)
        return KettenSystemGroup.UNKNOWN;
    const e41 = SYSTEM_KUERZEL[KettenSystemGroup.HALBSTEGIG_E4_1_OR_E4_00];
    const e61 = SYSTEM_KUERZEL[KettenSystemGroup.HALBSTEGIG_E61_OR_E6];
    const e44 = SYSTEM_KUERZEL[KettenSystemGroup.HALBSTEGIG_E4_4_OR_E4_light];
    if (e41.includes(EchainSystem)) {
        return KettenSystemGroup.HALBSTEGIG_E4_1_OR_E4_00;
    }
    else if (e61.includes(EchainSystem)) {
        return KettenSystemGroup.HALBSTEGIG_E61_OR_E6;
    }
    else if (e44.includes(EchainSystem)) {
        return KettenSystemGroup.HALBSTEGIG_E4_4_OR_E4_light;
    }
    return KettenSystemGroup.DEFAULT;
};
exports.findKettenSystemGroup = findKettenSystemGroup;
//# sourceMappingURL=KettenSystemGroup.js.map